<template>
  <div class="content-2">
    <h3>{{ transPeralbaPro.item799 }}</h3>
    <h4>{{ transPeralbaPro.item800 }}</h4>
    <div class="login-card" @click="clickParticular">
      <img
        class=""
        src="/front/hi/login-particular.svg"
        alt="login-particular"
      />
      <div>
        <p class="title-card">{{ transPeralbaPro.item801 }}</p>
        <p class="subtitle-card">{{ transPeralbaPro.item802 }}</p>
      </div>
      <img
        class="image-right"
        src="/front/hi/arrow-right-slide.svg"
        alt="arrow-right-slide"
      />
    </div>
    <div class="login-card" @click="clickProfesional">
      <img
        class=""
        src="/front/hi/login-profesional.svg"
        alt="login-profesional"
      />
      <div>
        <p class="title-card">{{ transPeralbaPro.item803 }}</p>
        <p class="subtitle-card">{{ transPeralbaPro.item804 }}</p>
      </div>
      <img
        class="image-right"
        src="/front/hi/arrow-right-slide.svg"
        alt="arrow-right-slide"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: ["transPeralbaPro"],
  methods: {
    clickParticular() {
      this.$emit("clickParticular");
    },
    clickProfesional() {
      this.$emit("clickProfesional");
    },
  },
};
</script>
